import React, { useEffect, useState } from "react";
import { getCurrentUser } from "./api";
import Login from "./components/Login";
import ShellV3 from "./components/ShellV3";
import ShellV4 from "./components/ShellV4";
import LeagueShell from "./components/LeagueShell";
import UmpireShell from "./components/UmpireShell";
import { ToastProvider } from "./components/Toast";
import { ThemeProvider } from "./components/Theme";
import { VersionProvider, useVersion } from "./components/Version";
import { WorkspaceProvider, useWorkspace } from "./components/Workspace";
import BrowserSupportBanner from "./components/BrowserSupportBanner";
import { canEnterWorkspace, availableWorkspaces } from "./data";

function AppInner({ user, setUser }) {
  const { version } = useVersion();
  const { workspace, setWorkspace } = useWorkspace();

  // Safety net: if the user's chosen workspace is no longer accessible
  // (e.g. their role was revoked, or they only have UMPIRE), fall back
  // to the first workspace they actually can enter so they never see
  // an empty shell.
  useEffect(() => {
    if (!user) return;
    if (!canEnterWorkspace(user, workspace)) {
      const options = availableWorkspaces(user);
      if (options.length) setWorkspace(options[0]);
    }
  }, [user, workspace, setWorkspace]);

  if (!user) return <Login onLogin={setUser} />;

  if (workspace === "league" && canEnterWorkspace(user, "league")) {
    return <LeagueShell user={user} setUser={setUser} version={version} />;
  }
  if (workspace === "umpire" && canEnterWorkspace(user, "umpire")) {
    return <UmpireShell user={user} setUser={setUser} />;
  }
  if (version === "v4") return <ShellV4 user={user} setUser={setUser} />;
  return <ShellV3 user={user} setUser={setUser} />;
}

export default function App() {
  const [user, setUser] = useState(getCurrentUser());
  return (
    <WorkspaceProvider>
      <VersionProvider>
        <ThemeProvider>
          <ToastProvider>
            <BrowserSupportBanner />
            <AppInner user={user} setUser={setUser} />
          </ToastProvider>
        </ThemeProvider>
      </VersionProvider>
    </WorkspaceProvider>
  );
}
